// This is src/components/SideMenu.js
import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import './SideMenu.css';
                                
import { FaChartLine, FaRegStar, FaChartBar, FaSearch} from 'react-icons/fa';
import { AiOutlineMenuFold, AiOutlineMenuUnfold } from 'react-icons/ai';

export default function SideMenu() {
  const [collapsed, setCollapsed] = useState(false);

                                  const menuItems = [
                                    { to: '/visualization', label: 'Stock Visualization', Icon: FaChartBar },
                                    { to: '/ratio-visualization', label: 'Stock Ratio Visualization', Icon: FaChartBar },
                                  { to: '/comparison', label: 'Stock Comparison', Icon: FaChartLine },
                                  { to: '/watchlist', label: 'Stock Watchlist', Icon: FaRegStar },
                                  { to: '/screener', label: 'Stock Screener', Icon: FaSearch },

                                 
                                  ];

  return (
    <nav className={`sidemenu ${collapsed ? 'collapsed' : ''}`}>
      

                                      <button
                                      className="collapse-button"
                                      onClick={() => setCollapsed(!collapsed)}
                                      aria-label={collapsed ? 'Expand menu' : 'Collapse menu'}
                                      >
                                      {collapsed ? <AiOutlineMenuUnfold /> : <AiOutlineMenuFold />}
                                      </button>
                                      <h2 className="sidemenu-title"> </h2>



      <ul className="sidemenu-list">
              {menuItems.map(({ to, label, Icon }) => (
          <li key={to}>
            <NavLink
              to={to}
              end={to === '/'}
              className={({ isActive }) =>
                isActive ? 'sidemenu-link active' : 'sidemenu-link'
              }
            >
              <Icon className="sidemenu-icon" />
              <span className="sidemenu-text">{label}</span>
            </NavLink>
          </li>
        ))}
      </ul>

    </nav>
  );
}
